import { Row } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';
import OnTraccrTextInput from '../common/inputs/OnTraccrTextInput';

export default function BucketOverrideNameFormItem({
  value,
  onChange,
  isDisplay,
}) {
  const [overrideNameChecked, setOverrideNameChecked] = useState(!!value)

  return (
    <Row>
      <OnTraccrCheckbox
        label="Override Name"
        value={overrideNameChecked}
        onChange={(newValue) => {
          setOverrideNameChecked(newValue);
          onChange(newValue ? '' : null);
        }}
        disabled={isDisplay}
        hoverNode="Enabling this will override the name of the downstream equipment with the name you provide below."
        style={{ marginTop: 5, marginRight: 10 }}
      />
      <OnTraccrTextInput
        value={value}
        onChange={onChange}
        disabled={!overrideNameChecked || isDisplay}
        style={{ width: 250 }}
      />
    </Row>
  );
}

BucketOverrideNameFormItem.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isDisplay: PropTypes.bool,
};

BucketOverrideNameFormItem.defaultProps = {
  value: null,
  onChange: null,
  isDisplay: false,
};
